import brandIcon from './brand_icon.png'
import checkMarkIcon from './check_mark.png'
import fastBoundLogo from './FastBoundLogo.png'

export default { brandIcon, checkMarkIcon, fastBoundLogo }
